module.exports = "//a1.xystatic.com/page/release/res/landing-h5/static/img/img.66d8be69.png";